import { Plus } from '@phosphor-icons/react';
import { CHATSERVE_URL } from '../../content/site';
import '../LandingPage.css';

interface Faq {
  question: string;
  answer: string;
  link?: { href: string; label: string };
}

const faqs: Faq[] = [
  {
    question: 'What kind of projects do you take on?',
    answer:
      'Mostly web applications for businesses: internal tools, customer portals, ordering and booking systems, and the APIs and integrations behind them. If you are not sure whether your project fits, ask us.',
  },
  {
    question: 'Do you only build software for restaurants?',
    answer:
      'No. ChatServe is our own product for restaurants and bars. Our client work covers other industries, including healthcare, finance and e-commerce.',
  },
  {
    question: 'Which technologies do you use?',
    answer:
      'Our usual stack is React and TypeScript in the browser, .NET for back ends and APIs, and Microsoft Azure for hosting. If your business already runs on other technology, we can work with that too.',
  },
  {
    question: 'How much does a project cost?',
    answer:
      'It depends on what the application needs to do. After the first conversation we send you a written estimate. The first conversation costs nothing.',
  },
  {
    question: 'Can you look after an application once it is live?',
    answer:
      'Yes. We host and update applications after launch, the same way we run ChatServe.',
  },
  {
    question: 'Can my restaurant use ChatServe?',
    answer:
      'ChatServe is available to restaurants and bars in Romania and Spain. The ChatServe website explains what it includes and how to sign up.',
    link: { href: CHATSERVE_URL, label: 'Visit the ChatServe website' },
  },
];

// FAQ structured data for search and answer engines.
const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: { '@type': 'Answer', text: faq.answer },
  })),
};

function FaqSection() {
  return (
    <section id="faq" className="faq-section section" aria-labelledby="faq-title">
      <div className="section-content faq-content">
        <div className="section-head reveal">
          <h2 id="faq-title" className="section-title">Questions people ask us</h2>
        </div>

        <div className="faq-list reveal">
          {faqs.map((faq) => (
            <details key={faq.question} className="faq-item">
              <summary className="faq-question">
                <span>{faq.question}</span>
                <Plus className="faq-icon" size={20} weight="bold" aria-hidden="true" />
              </summary>
              <div className="faq-answer">
                <p>{faq.answer}</p>
                {faq.link && (
                  <a href={faq.link.href} target="_blank" rel="noopener noreferrer" className="text-link">
                    {faq.link.label}
                    <span className="sr-only"> (opens in a new tab)</span>
                  </a>
                )}
              </div>
            </details>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </section>
  );
}

export default FaqSection;
